export default function containsToken(string: string, search: string) {
  const trimRegex = /\s+/g;

  return string
    .replace(trimRegex, "")
    .toLowerCase()
    .includes(search.replace(trimRegex, "").toLowerCase());
}
